<script setup>
    import { onMounted, ref } from 'vue';

    import Sidebar from '@/components/siderbar/SidebarComponent';
    import { sidebarWidth } from '@/components/siderbar/state';
    import useSettings from '@/composables/useSettings';

    const { loading, form, formRef, formRules, readSettings, onSaveSettings, verifyForm, verifyFormRef, verifyFormRules, verifyOptions, showModal, onVerifyConfirm, onSend2FA, sending,
        checkingPhoneNumber,
        checkingEmail,
        timer, } = useSettings();

    onMounted(() => {
        setTimeout(() => {
            readSettings();
        }, 50);
    });
</script>

<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <div class="top" style="height:60px;"></div>

            <h4 class="mb-6 font-semibold">Log-In Settings</h4>

           <div class="bg-gray-100 min-h-screen flex flex-col  p-4 rounded-xl"  v-if="form!=null">
      

                <p class="text-xl font-semibold mt-6">Personal Information</p>

                <n-form ref="formRef" size="large" :rules="formRules" :model="form" label-placement="top">
                    <n-grid :x-gap="25" :y-gap="4" class="mt-1"  responsive="screen" item-responsive>
                        <n-form-item-gi span="24 m:12" path="FirstName" label="Please provide your first name" class="">
                            <n-input v-model:value="form.FirstName" placeholder="First Name" :maxlength="100" clearable />
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" path="LastName" label="Please provide your last name">
                            <n-input v-model:value="form.LastName" placeholder="Last Name" :maxlength="100" clearable />
                        </n-form-item-gi>

                        <n-form-item-gi span="24" :show-label="false" :show-feedback="false">
                            <n-divider class="!mt-1 bg-gray-300" dashed />
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" :show-label="false" path="Email">
                            <div class="w-full">
                                <p class="text-xl font-semibold">Log-In Username</p>
                                <p class="text-gray-400 mt-2">This username is the email address you use to Log-In.</p>
                                <n-input v-model:value="form.Email" placeholder="Ex. youremail@domain.com" :maxlength="300" />
                            </div>
                        </n-form-item-gi>

                        <n-form-item-gi span="24 m:12"  :show-feedback="false" style="display: none;">
                            <n-space :size="23" vertical class="ml-0 md:ml-4 !w-full mt-6" justify="space-between" >
                                <n-checkbox size="large" v-model:checked="form.EnableEmailTwoFactor" label="Check this box to opt into two factor authentication security codes sent to this email" />
                                <n-checkbox size="large" v-model:checked="form.ReceiveGeneralEmailNotifications" label="Check this box to have general notifications sent to this email." />
                            </n-space>
                        </n-form-item-gi>

                        <n-form-item-gi span="24" :show-label="false" :show-feedback="false" style="display: none;">
                            <n-divider class="!mt-4 bg-gray-300" dashed />
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" :show-label="false" path="AlternateEmail" style="display: none;">
                            <div class="w-full">
                                <p class="text-xl font-semibold">Alternate Email</p>
                                <p class="text-gray-400 mt-2">Enter an alternate email here if you prefer to receive notifications to an email other than the one you used for your Username.</p>
                                <n-input v-model:value="form.AlternateEmail" placeholder="Ex. youremail@domain.com" :maxlength="300" />
                            </div>
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" :show-label="false" :show-feedback="false" style="display: none;">
                            <n-space :size="23" vertical class="ml-0 md:ml-4 mt-8 !w-full mt-10" justify="space-between">
                                <n-checkbox size="large" v-model:checked="form.ReceiveGeneralAlternateEmailNotifications" label="Check this box to receive general notifications via this email." />
                            </n-space>
                        </n-form-item-gi>


                        <n-form-item-gi span="24" :show-label="false" :show-feedback="false">
                            <n-divider class="!mt-4 bg-gray-300" dashed />
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" :show-label="false" path="PhoneNumber">
                            <div class="w-full">
                                <p class="text-xl font-semibold">Mobile Number</p>
                                <p class="text-gray-400 mt-2">This is the 9-digit number whereby your 2-factor security codes will be sent</p>
                                <n-input v-model:value="form.PhoneNumber" placeholder="6475555555" :maxlength="50" autocomplete="off" />
                            </div>
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:12" :show-label="false" :show-feedback="false" style="display: none;">
                            <n-space :size="23" vertical class="ml-0 md:ml-4 !w-full mt-10" justify="space-between">
                                <n-checkbox size="large" v-model:checked="form.EnableSmsTwoFactor" label="Check this box to opt into two factor authentication via SMS sent to  this mobile number" />
                                <n-checkbox size="large" v-model:checked="form.ReceiveGeneralSmsNotifications" label="Check this box to have general notifications via SMS sent to this mobile number" />
                            </n-space>
                        </n-form-item-gi>


                        <n-form-item-gi span="24" :show-label="false" :show-feedback="false">
                            <n-divider class="!mt-4 bg-gray-300" dashed />
                        </n-form-item-gi>
                        <n-form-item-gi span="24" :show-label="false">
                            <div class="w-full">
                                <p class="text-xl font-semibold">Change Password</p>
                                <p class="text-gray-400 mt-2 ">Create a new password for your account. Your password must meet the following requirements:</p>
                                <ul class="list-disc list-inside text-zinc-600 dark:text-zinc-300 mt-2">
                                    <li>Minimum 8 characters</li>
                                    <li>At least one uppercase letter</li>
                                    <li>At least one lowercase letter</li>
                                    <li>At least one number</li>
                                    <li>At least one special character (!@#$%^&*)</li>
                                    <li>Cannot contain spaces</li>
                                </ul>
                            </div>
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:8" :show-label="false" path="Password">
                            <n-input v-model:value="form.Password" type="password" placeholder="Old Password" autocomplete="off" :maxlength="100" show-password-on="click" />
                        </n-form-item-gi>
                        <n-form-item-gi span="24 m:8" :show-label="false" path="NewPassword">
                            <n-input v-model:value="form.NewPassword" type="password" placeholder="New Password" autocomplete="off" :maxlength="100" show-password-on="click" />
                        </n-form-item-gi>

                        <n-form-item-gi span="24 m:8" :show-label="false" path="ConfirmPassword">
                            <n-input v-model:value="form.ConfirmPassword" type="password" placeholder="Confirm Password" autocomplete="off" :maxlength="100" show-password-on="click" />
                        </n-form-item-gi>

                    </n-grid>
                </n-form>

                <n-button class="w-full md:!w-[200px] flex my-12 " style="align-self: self-end;" size="large" type="primary" block strong :loading="loading" @click="onSaveSettings">Save Changes</n-button>

            </div>
        </div>

        <n-modal v-model:show="showModal">
            <n-card class="max-w-xl"
                    title="IDENTITY VERIFICATION"
                    :bordered="false"
                    size="huge"
                    role="dialog"
                    aria-modal="true">
                <p class="text-base">
                    For your protection, we need to verify your identity.<br>
                    Select a contact method below and we will send you a one-time verification code to enter.
                </p>
                <n-form ref="verifyFormRef" size="large" :rules="verifyFormRules" :model="verifyForm">
                    <n-grid :x-gap="10" :y-gap="4" class="!mt-8">
                        <n-form-item-gi span="15" label="Email Address or Mobile Number" :show-label="false" path="account">
                            <n-select v-model:value="verifyForm.account" :options="verifyOptions" />
                        </n-form-item-gi>
                        <n-form-item-gi span="9" label="" :show-label="false">
                            <n-button @click="onSend2FA(verifyForm)" :loading="sending" :disabled="timer > 0" class="w-full">{{ timer > 0 ? `Get Code (${timer}s)` : 'Get Code' }}</n-button>
                        </n-form-item-gi>
                        <n-form-item-gi span="24" label="Verification Code" path="token" :show-label="false">
                            <n-input v-model:value="verifyForm.token" placeholder="Enter the verification code" :maxlength="20" autocomplete="off" clearable />
                        </n-form-item-gi>
                    </n-grid>
                </n-form>
                <template #footer>
                    <div class="flex justify-end">
                        <n-button class="w-full md:!w-[110px] mr-4" block strong @click="showModal=false">Cancel</n-button>
                        <n-button class="w-full md:!w-[110px]" type="primary" block strong :loading="loading" @click="onVerifyConfirm">Confirm</n-button>
                    </div>
                </template>
            </n-card>
        </n-modal>
    </div>

</template>
<style scoped>
    .subscription {
        padding: 20px;
        width: 100%;
    }

    .toolbBar {
    margin-top:20px;
    }
    #app {
        height: 100vh;
    }

    .nav-link {
        color: white;
        width: 100%;
    }

        .nav-link.active {
        }


    @media (max-width: 1024px) {
        /* Mobile version */
        .n-grid{display: block !important;}
    }
</style>

